import React from 'react'
import styled from 'styled-components'

export const Wrapper = styled.ul`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  margin-bottom: -5px;
  pointer-events: none;
  padding: 0;

  .tag-wrapper {
    display: block;
    max-width: 280px;
    max-height: 250px;
    overflow-y: auto;
    background-color: #fff;
    border-radius: 6px;
    padding: 10px 10px 5px 10px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.18);
    position: fixed;
    opacity: 0;
    visibility: hidden;
    z-index: 1050;
    pointer-events: auto;
  }

  &:hover {
    .tag-wrapper {
      opacity: ${props => (props.noHover ? 0 : 1)};
      visibility: visible;
    }
  }
`
export const Tag = styled.li`
  display: inline-block;
  font-size: 12px;
  border: 1px solid #91d5ff;
  border-radius: 4px;
  padding: 2px 10px;
  max-width: 240px;
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
  margin-right: 5px;
  margin-bottom: 5px;
  white-space: nowrap;
  color: #1890ff;
  background: #e6f7ff;
`
export const ShowAllTagsButton = styled.span`
  font-size: 12px;
  border-radius: 50%;
  text-align: center;
  width: 25px;
  height: 25px;
  line-height: 22px;
  pointer-events: auto;
  border: 1px solid #91d5ff;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1890ff;
  background: #e6f7ff;
  transition: all 0.2s ease;

  &:hover {
    cursor: pointer;
    background: #1890ff;
    color: #fff;
    border-color: #1890ff;
  }
`
